import React, { useEffect, useState } from "react";
import { INSTRUMENTS, tick } from "@/lib/market";
import { useLiveRates, mergeLive } from "@/lib/liveRates";

const FLAT = Object.entries(INSTRUMENTS).flatMap(([cat, arr]) => arr.map((i) => ({ ...i, cat })));

export default function MarketTicker() {
  const { live } = useLiveRates();
  const [rows, setRows] = useState(FLAT);

  useEffect(() => { setRows((prev) => mergeLive(prev, live)); }, [live]);

  useEffect(() => {
    const id = setInterval(() => {
      setRows((prev) => prev.map((r) => {
        const np = tick(r.p);
        return { ...r, p: np, d: +((r.d + (Math.random() - 0.5) * 0.05).toFixed(2)) };
      }));
    }, 1600);
    return () => clearInterval(id);
  }, []);

  const doubled = [...rows, ...rows];

  return (
    <div className="marquee-wrap overflow-hidden bg-[#06122E] border-y border-[#203E70] py-2" data-testid="market-ticker">
      <div className="marquee flex gap-8 whitespace-nowrap w-max">
        {doubled.map((r, i) => (
          <span key={i} className="inline-flex items-center gap-2 font-mono text-sm">
            <span className="text-slate-400">{r.s}</span>
            <span className="text-white">{r.p}</span>
            <span className={r.d >= 0 ? "ticker-up" : "ticker-down"}>
              {r.d >= 0 ? "▲" : "▼"} {Math.abs(r.d).toFixed(2)}%
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
